import React from 'react';
import { useTranslation } from 'react-i18next'
import { Tooltip } from "../../../components/Utils/Tooltips";
import { Add, Copy, Down, Edit, Remove, Up, View } from '../../../components/Icons/Icons';

const DeleteAllUsers = ({ deleteAllPatients }) => {
    const { t } = useTranslation(); 

    return (
        
        <div className="col-md-3">
            <button type="button" className="btn btn-danger" onClick={deleteAllPatients}><Remove />{t('protocols.groups.deleteAll')}</button >
        </div>

    );
};

export default DeleteAllUsers;